module.exports = __webpack_public_path__ + "img/ma278.6006806c.png";